import React from "react"

const UserAuthCreationFormLoadable = React.lazy(() => import("./UserAuthCreationForm"));

export { UserAuthCreationFormLoadable };